import { render, staticRenderFns } from "./BranchCapitalSetting.vue?vue&type=template&id=afad7538&scoped=true&"
import script from "./BranchCapitalSetting.vue?vue&type=script&lang=js&"
export * from "./BranchCapitalSetting.vue?vue&type=script&lang=js&"
import style0 from "./BranchCapitalSetting.vue?vue&type=style&index=0&id=afad7538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afad7538",
  null
  
)

export default component.exports